import { getInstallButtonClickedEvent, getMarketplaceInteractionEvent, getPageViewedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
export const SCREEN = 'listing details';
export const useTracking = ({
  listingId,
  sourceId,
  slug,
  type,
  appContext,
  embed,
  isPreview
}) => {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackInteraction = eventProps => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getMarketplaceInteractionEvent(Object.assign({
      screen: SCREEN,
      type,
      listingId,
      sourceId: [sourceId],
      embed,
      slug,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public'
    }, eventProps)));
  };
  const trackInstall = eventProps => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getInstallButtonClickedEvent(Object.assign({
      screen: SCREEN,
      type,
      listingId,
      sourceId: [sourceId],
      embed,
      slug,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public'
    }, eventProps)));
  };
  const trackPageViewed = () => {
    if (isPreview) {
      return;
    }
    trackMarketplaceEvent(getPageViewedEvent({
      screen: SCREEN,
      type,
      slug,
      embed,
      inAppOrPublic: appContext === 'app' ? 'in-app' : 'public'
    }));
  };
  return {
    trackInstall,
    trackInteraction,
    trackPageViewed
  };
};